import { TabsContent } from '@/components/ui/tabs';
import {
  FundInvestorsList,
  type InvestorFundTransferDraftPayload,
} from '@/components/fund-detail/FundInvestorsList';
import { FundInvestorsSummaryCards } from '@/components/fund-detail/FundInvestorsSummaryCards';
import type { Fund } from '@/types/fund';
import type { InvestorDetail } from '@/types/investor';

interface InvestorsTabProps {
  fund: Fund;
  fundInvestors?: InvestorDetail[];
  investorsKey: number;
  onAddInvestor: () => void;
  onInvestorsChange: () => void;
  onInitiateTransfer?: (
    payload: InvestorFundTransferDraftPayload
  ) => Promise<void> | void;
}

export function FundInvestorsTab({
  fund,
  fundInvestors,
  investorsKey,
  onAddInvestor,
  onInvestorsChange,
  onInitiateTransfer,
}: InvestorsTabProps) {
  return (
    <TabsContent value="investors" className="space-y-6">
      {fundInvestors && (
        <FundInvestorsSummaryCards fund={fund} fundInvestors={fundInvestors} />
      )}
      <FundInvestorsList
        fund={fund}
        fundInvestors={fundInvestors}
        key={investorsKey}
        onAddInvestor={onAddInvestor}
        onInvestorsChange={onInvestorsChange}
        onInitiateTransfer={onInitiateTransfer}
      />
    </TabsContent>
  );
}
